export default __webpack_public_path__ + "static/media/(53).a2a3ad6d.jpg";